/*
Author:      Zachary Thomas
Created:     8/23/2021
Modified:    7/20/2022

Copyright 2021 - 2022 © Cornell Pump Company, All Rights Reserved
-----------------------------------------------------------------
*/

import React from "react";
import Card from "../../components/Card/Card";
import TextBlurb from "../../components/TextBlurb/TextBlurb";
import styles from "./Error500Page.module.scss";

// Page for displaying 500 errors.
export default function Error500Page(): Component {
  return (
    <div className={`${styles.body} p-4`}>
      <Card title="Internal Server Error">
        <div className="my-5">
          <TextBlurb
            title="Something went wrong!"
            paragraph="We were unable to display the page you were looking for. Please go back to the previous page and try again."
            icon="exclamation-triangle"
          />
        </div>
      </Card>
    </div>
  );
}
